import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

// Only forward to same-origin destinations so a crafted `redirect` cannot turn
// this token-adopting route into an open redirect. Bare `/back-office` is fine:
// the CMS router self-heals it to the caller's own workspace-scoped URL.
const resolveSafeRedirect = (raw: string | null): string => {
  if (!raw) return '/back-office'
  try {
    const target = new URL(raw, window.location.origin)
    return target.origin === window.location.origin
      ? `${target.pathname}${target.search}${target.hash}`
      : '/back-office'
  } catch (error) {
    return '/back-office'
  }
}

/**
 * SSO inbound-token landing route.
 *
 * Cross-domain callers (e.g. the ERP exiting an impersonation session) cannot
 * write the CMS localStorage directly, so they hand the freshly minted token
 * via the `#token=` hash and the destination via `?redirect=`. This page adopts
 * the token, then forwards to the (same-origin) destination — defaulting to the
 * back-office page, which the router resolves to the caller's own workspace.
 */
const SSOPageRawLogin = () => {
  useEffect(() => {
    const hash = window.location.hash.replace(/^#/, '')
    const token = new URLSearchParams(hash).get('token')
    if (token) {
      localStorage.setItem('token', token)
    }

    const redirect = new URLSearchParams(window.location.search).get('redirect')
    window.location.href = resolveSafeRedirect(redirect)
  }, [])

  return <>System is signing you in...</>
}

export const SSOLoginPage = withRouter(SSOPageRawLogin)
